import { ArrowRight, MapPin } from "lucide-react";
import { REALISATIONS } from "@/lib/site-data";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

// Bento layout spans for up to 6 photos in a 3-col grid
const SPANS = [
  "md:col-span-2 md:row-span-2", // 0 — big featured
  "md:col-span-1",               // 1
  "md:col-span-1",               // 2
  "md:col-span-1",               // 3
  "md:col-span-1",               // 4
  "md:col-span-1",               // 5
];

const ASPECTS = [
  "aspect-[1/1] md:aspect-[4/5]", // big square-ish
  "aspect-[4/3]",
  "aspect-[4/3]",
  "aspect-[4/3]",
  "aspect-[4/3]",
  "aspect-[4/3]",
];

export const Gallery = () => {
  return (
    <section id="realisations" data-testid="gallery-section" className="relative py-24 md:py-32 asphalt-thin border-y border-bgtp-line">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <div className="eyebrow mb-4">Nos réalisations</div>
            <h2 className="font-heading text-5xl md:text-7xl uppercase tracking-tight text-white leading-[0.9]">
              Du chantier <span className="orange-metal-text">à la finition.</span>
            </h2>
          </div>
          <p className="max-w-md text-white/70 text-sm">
            Quelques aperçus de nos derniers chantiers — terrassement, aménagement extérieur,
            création de cour et maçonnerie dans l'Ain.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 md:auto-rows-fr gap-5">
          {REALISATIONS.map((r, i) => (
            <figure
              key={r.url}
              data-testid={`realisation-${i}`}
              className={`group relative overflow-hidden border border-bgtp-line bg-bgtp-ink ${SPANS[i] || "md:col-span-1"}`}
            >
              <div className={`w-full h-full overflow-hidden ${ASPECTS[i] || "aspect-[4/3]"}`}>
                <img
                  src={r.url}
                  alt={r.title}
                  loading="lazy"
                  className="w-full h-full object-cover grayscale-[15%] group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent opacity-90 group-hover:opacity-70 transition-opacity pointer-events-none" />
              <figcaption className="absolute left-0 right-0 bottom-0 p-5 md:p-6">
                <div className="text-[10px] tracking-[0.3em] uppercase text-bgtp-orange mb-2">{r.tag}</div>
                <div className={`font-heading uppercase tracking-wider text-white ${i === 0 ? "text-3xl md:text-4xl" : "text-xl md:text-2xl"}`}>{r.title}</div>
                <div className="mt-2 flex items-center gap-2 text-xs text-bgtp-steel">
                  <MapPin className="w-3 h-3" /> {r.location}
                </div>
              </figcaption>
              <div className="absolute top-4 left-4 font-heading text-bgtp-orange text-xl">0{i + 1}</div>
            </figure>
          ))}

          {/* CTA card — spans the bottom row */}
          <button
            data-testid="gallery-cta"
            onClick={() => scrollTo("contact")}
            className="group relative text-left md:col-span-3 border border-bgtp-line bg-bgtp-ink hover:border-bgtp-orange transition-all p-8 md:p-10 flex flex-col md:flex-row md:items-center md:justify-between gap-6 overflow-hidden"
          >
            <div className="absolute inset-0 opacity-30 group-hover:opacity-50 transition-opacity pointer-events-none" style={{ background: "radial-gradient(circle at 80% 20%, rgba(242,107,31,0.45), transparent 60%)" }} />
            <div className="relative max-w-2xl">
              <div className="text-[10px] tracking-[0.3em] uppercase text-bgtp-orange mb-3">Votre projet · 07</div>
              <div className="font-heading text-3xl md:text-5xl uppercase tracking-wider text-white leading-tight">
                Le prochain chantier <span className="text-bgtp-orange">sera le vôtre ?</span>
              </div>
              <p className="mt-4 text-sm text-white/70">
                Décrivez-nous votre besoin — terrassement, cour, allée ou rénovation —
                on revient avec un devis clair sous 48h.
              </p>
            </div>
            <div className="relative inline-flex items-center gap-2 text-bgtp-orange font-heading uppercase tracking-wider text-xl">
              Demander un devis <ArrowRight className="w-6 h-6 transition-transform group-hover:translate-x-1" />
            </div>
          </button>
        </div>
      </div>
    </section>
  );
};
